import "./SingleSmartHomeTipTemplate.module.css"
import Navigation from "@/reusable_sections/Header"
import SingleSmartHomeTipTemplateSection from "./sections/SingleSmartHomeTipTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleSmartHomeTipTemplatePage() {

  return (
    <div>
      <Navigation />
      <SingleSmartHomeTipTemplateSection />
      <Footer />
    </div>
  )
}
